import { NgModule } from '@angular/core';

import { NavModule } from '@mt-ng2/nav-module';
import { NavSidebarServiceToken, NavModuleConfigToken } from '@mt-ng2/nav-module-config';

import { NavConfigOverride } from '@common/configs/nav.config';
import { NavSidebarService } from './sidebar.service';

@NgModule({
    exports: [NavModule],
    imports: [NavModule],
})
export class AppNavModule {
    static forRoot(): any {
        return {
            ngModule: AppNavModule,
            providers: [
                { provide: NavSidebarServiceToken, useClass: NavSidebarService },
                { provide: NavModuleConfigToken, useValue: NavConfigOverride },
            ],
        };
    }
}
